import React, { Component } from 'react'
import { faInfoCircle, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class CollapseInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            title: this.props.titleTrue
        }

        this.togglePanel = this.togglePanel.bind(this);
        this.getIcon = this.getIcon.bind(this);
    }

    togglePanel(e) {
        this.setState({ open: !this.state.open })
        if (this.state.open) {
            this.setState({ title: this.props.titleTrue })
        }
        else {
            this.setState({ title: this.props.titleFalse })
        }
        // to do, make icon/ title change as it's clicked to collapse or expand
    }

    getIcon(type) {
        var iconName = [];
        switch (type) {
            case 'moreInfo':
                iconName = faInfoCircle;
                break;
            case 'showHide':
                if (this.state.open) {
                    iconName = faChevronUp;
                    break;
                } else {
                    iconName = faChevronDown;
                    break;
                }
            default:
                break;
        }

        return (iconName)
    }

    render() {
        return (
            <div className={this.props.classCollapseInfoContainer}>
                <div onClick={(e) => this.togglePanel(e)} className={this.props.classCollapseHeader}>
                    <FontAwesomeIcon icon={this.getIcon(this.props.Type)} />
                    {' ' + this.state.title}</div>
                {this.state.open ? (
                    <div className={this.props.classCollapseInfoContent}>
                        {this.props.children}
                    </div>
                ) : null}
            </div>);
    }
}